import { SVGProps } from '@components/Icon/types';

export const ZoomOut = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.35, 2.35)">
      <path
        d="M4.65 6.94998C4.26341 6.94998 3.95 7.26338 3.95 7.64998C3.95 8.03658 4.26341 8.34998 4.65 8.34998H10.65C11.0366 8.34998 11.35 8.03658 11.35 7.64998C11.35 7.26338 11.0366 6.94998 10.65 6.94998H4.65Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.69907 0C3.46014 0 0 3.46014 0 7.69907C0 11.938 3.46014 15.3981 7.69907 15.3981C9.43555 15.3981 11.0362 14.8112 12.3287 13.832L12.5718 13.6479L17.9913 19.0662C18.0613 19.1392 18.1452 19.1975 18.238 19.2376C18.3309 19.2777 18.4308 19.2989 18.5319 19.3C18.6331 19.301 18.7334 19.2818 18.8271 19.2436C18.9207 19.2054 19.0058 19.1488 19.0773 19.0773C19.1488 19.0058 19.2054 18.9207 19.2436 18.8271C19.2818 18.7334 19.301 18.6331 19.3 18.5319C19.2989 18.4308 19.2777 18.3309 19.2376 18.238C19.1975 18.1452 19.1392 18.0613 19.0662 17.9912L19.0611 17.9862L13.6479 12.5718L13.832 12.3287C14.8112 11.0362 15.3981 9.43555 15.3981 7.69907C15.3981 3.46014 11.938 0 7.69907 0ZM1.52043 7.69907C1.52043 4.27355 4.27355 1.52043 7.69907 1.52043C11.1246 1.52043 13.8777 4.27355 13.8777 7.69907C13.8777 9.34379 13.2383 10.8302 12.1997 11.9342L12.1769 11.9584L12.15 11.9778C12.0847 12.0251 12.0273 12.0825 11.98 12.1479L11.9606 12.1747L11.9365 12.1974C10.8323 13.2374 9.34498 13.8777 7.69907 13.8777C4.27355 13.8777 1.52043 11.1246 1.52043 7.69907Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'zoom-out';
